import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';
import { PageService } from '../page.service';

@Component({
  selector: 'modal-filtro',
  templateUrl: './modal-filtro.component.html',
  styleUrls: ['./modal-filtro.component.scss'],
})
export class ModalFiltroComponent implements OnInit, OnDestroy {

  @Input() label = 'Filtrar';
  @Input() situacaoModal: Observable<boolean> = null;
  private situacaoInscricao: Subscription;
  situacao = false;

  constructor(private page: PageService) { }

  ngOnInit() {
    if (this.situacaoModal) {
      this.situacaoInscricao = this.situacaoModal.subscribe(this.mostrarModal.bind(this));
    }
  }

  ngOnDestroy() {
    if (this.situacaoInscricao) {
      this.situacaoInscricao.unsubscribe();
    }
  }

  fecharModal() {

    this.mostrarModal(false);
  }

  mostrarModal(status) {
    this.situacao = !!status;
    this.situacao ? this.page.mobile().lockScroll() : this.page.mobile().unlockScroll();
  }
}
